import Map from './../map/map';

export default new class Shops {
  constructor() {
    this.sSelectClass = '_shops_change_city_select';
    this.sMapWrapperClass = '_shops_map_wrapper';
    this.sShopsWrapperClass = '_shops_shops_wrapper';

    this.obMap = new Map();
    this.obMap.init();

    this.update();
  }

  update() {
    $(document).on('change', `.${this.sSelectClass}`, (obEvent) => {
      const iCityId = $(obEvent.target).val();
      const self = this;
      $.request('onInit', {
        data: {
          'city_id': iCityId
        },
        update: {
          'shops/map': `.${this.sMapWrapperClass}`,
          'shops/shops': `.${this.sShopsWrapperClass}`
        },
        complete: function () {
          self.obMap.init();
        },
      });
    });
  }
}();
